import React from "react";

import NetworkSearchBanner from "../components/banner/NetworkSearchBanner";
import NetworkSearch from "../components/search/NetworkSearch";

function ProviderSearch() {
  return (
    <>
      <NetworkSearchBanner />
      <NetworkSearch isProviderNetworkSearch={false} />
    </>
  );
}

export default ProviderSearch;
